import styled from 'styled-components'

import { helpers } from 'styles'

export const ErrorWrapper = styled.div`
	margin: 0 -${helpers.spacing.large};
	padding: ${helpers.spacing.large} ${helpers.spacing.large} 0;
	width: calc(100% + ${helpers.spacing.xxLarge});

	border-top: 1px solid ${helpers.color.border};
`
